import { useShallow } from "zustand/shallow";
import useWorkflowStore from "../stores/useWorkflowStore";
import { SCAN_PROCESS_STEPS, MAIN_PROCESS_STEPS } from "../constants/flowConfig";

//All Handlers
// import { PreparingScanHandler } from "./tool_handlers/preparing_scan/PreparingScanHandler";
// import AxesAlignmentHandler from "./tool_handlers/axes_alignment/AxesAlignmentHandler";
// import RectificationHandler from "./tool_handlers/rectification/RectificationHandler";
// import { ElongationHandler } from "./tool_handlers";
import { PreparingScanHandler, AxesAlignmentHandler,
    RectificationHandler, ElongationHandler, TrimlineHandler, ThicknessHandler, FlaresHandler } from "./tool_handlers";


export function ToolHandler()
{
    const [currentStep] = useWorkflowStore(
        useShallow((state) => [
            state.currentStep
        ])
    );

    const getTool = () =>
    {
        switch(currentStep)
        {
            case SCAN_PROCESS_STEPS.PREPARING_SCAN:
                return <PreparingScanHandler/>
            case SCAN_PROCESS_STEPS.AXES_ALIGNMENT:
                return <AxesAlignmentHandler />
            case MAIN_PROCESS_STEPS.RECTIFICATION:
                return <RectificationHandler />
            case MAIN_PROCESS_STEPS.ELONGATION:
                return <ElongationHandler />
            case MAIN_PROCESS_STEPS.TRIMLINE:
                return <TrimlineHandler />
            case MAIN_PROCESS_STEPS.THICKNESS:
                return <ThicknessHandler />
            case MAIN_PROCESS_STEPS.FLARES:
                return <FlaresHandler />
            default:
                return null;
        }
    }

    return (
        <div className="absolute left-0 top-0 w-full h-full -z-10">
            {getTool()}
        </div>
    );
}